import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';

@Component({
  selector: 'ngx-new-tpslRoute-modal',
  templateUrl: './new-tpslRoute-modal.component.html',
  styleUrls: ['./new-tpslRoute-modal.component.scss']
})
export class NewTpslRouteModal implements OnInit {


  constructor(public dialogRef: MatDialogRef<NewTpslRouteModal>) {}

  ngOnInit(): void {}


  onDismiss() {
    this.dialogRef.close(false);
  }

}
